(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    class MarqueeBlock extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.run = this.querySelector('[data-marquee-run]');
      if (!this.track || !this.run) return;

      this.sourceHTML = this.run.innerHTML;
      this.build();

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleBuild());
        this.observer.observe(this);
      } else {
        this.onResize = () => this.scheduleBuild();
        window.addEventListener('resize', this.onResize);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleBuild());
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      clearTimeout(this.timer);
    }

    scheduleBuild() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.build(), 200);
    }

    build() {
      if (!this.sourceHTML.trim()) return;
      if (this.dataset.animateOn === 'never') {
        this.setAttribute('data-ready', '');
        return;
      }

      const clone = this.track.querySelector('.block-marquee__run[aria-hidden="true"]');
      if (clone) clone.remove();
      this.run.innerHTML = this.sourceHTML;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const available = this.clientWidth;
      if (!available) return;

      const items = Array.from(this.run.children);
      let guard = 0;
      while (this.run.scrollWidth < available && items.length && guard < 50) {
        for (const item of items) this.run.appendChild(this.copy(item));
        guard += 1;
      }

      const runWidth = this.run.getBoundingClientRect().width;
      if (!runWidth) return;

      const second = this.run.cloneNode(true);
      second.setAttribute('aria-hidden', 'true');
      second.removeAttribute('data-marquee-run');
      this.stripEditorAttributes(second);
      this.track.appendChild(second);

      const speed = parseFloat(this.dataset.speed) || 40;
      this.style.setProperty('--marquee-duration', (runWidth + gap) / speed + 's');
      this.setAttribute('data-ready', '');
    }

    copy(node) {
      const item = node.cloneNode(true);
      item.setAttribute('aria-hidden', 'true');
      this.stripEditorAttributes(item);
      return item;
    }

    stripEditorAttributes(node) {
      const nodes = [node].concat(Array.from(node.querySelectorAll('[id], [data-shopify-editor-block]')));
      for (const el of nodes) {
        el.removeAttribute('id');
        el.removeAttribute('data-shopify-editor-block');
      }
    }
  }

  if (!customElements.get('marquee-block')) {
    customElements.define('marquee-block', MarqueeBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["os-accordion"] && !Shopify.designMode) return;
  try {
    // "One open at a time": close the other items when one opens. The toggle
  // event doesn't bubble, so it's caught on the way down.
  if (!customElements.get('os-accordion')) {
    customElements.define(
      'os-accordion',
      class extends HTMLElement {
        connectedCallback() {
          this.onToggle = (event) => {
            const item = event.target;
            if (!this.hasAttribute('data-single') || !(item instanceof HTMLDetailsElement) || !item.open) return;
            if (item.closest('os-accordion') !== this) return;
            this.querySelectorAll('details.os-acc__item[open]').forEach((other) => {
              if (other !== item && other.closest('os-accordion') === this) other.open = false;
            });
          };
          this.addEventListener('toggle', this.onToggle, true);
        }

        disconnectedCallback() {
          this.removeEventListener('toggle', this.onToggle, true);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["os-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    let loader = null;
    const loadSwiper = (src) => {
      if (window.Swiper) return Promise.resolve();
      if (!loader) {
        loader = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = resolve;
          script.onerror = () => {
            loader = null;
            reject();
          };
          document.head.appendChild(script);
        });
      }
      return loader;
    };

    // Attributes Swiper writes on the elements it is given. Destroying it with
    // cleanStyles would remove each slide's whole style attribute (the os-
    // blocks keep their sizing variables there), so they are saved before
    // and restored after instead.
    const KEPT = ['style', 'role', 'aria-label', 'aria-roledescription', 'aria-live', 'id'];

    class OsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.os-carousel__viewport');
        this.track = this.querySelector('.os-carousel__track');
        if (!this.viewport || !this.track) return;
        if (this.dataset.motion === 'marquee') {
          this.setupMarquee();
          return;
        }
        const on = this.dataset.on;
        this.mq =
          on === 'mobile'
            ? window.matchMedia('(max-width: 749px)')
            : on === 'desktop'
              ? window.matchMedia('(min-width: 750px)')
              : null;
        this.onChange = () => this.sync();
        this.mq?.addEventListener('change', this.onChange);
        this.onSelect = (event) => this.reveal(event.target);
        document.addEventListener('shopify:block:select', this.onSelect);
        this.sync();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
        this.mq?.removeEventListener('change', this.onChange);
        document.removeEventListener('shopify:block:select', this.onSelect);
        this.teardown();
      }

      slides() {
        return [...this.track.children].filter(
          (el) => !['STYLE', 'SCRIPT', 'LINK', 'TEMPLATE'].includes(el.tagName) && !el.hasAttribute('data-os-clone')
        );
      }

      active() {
        return (!this.mq || this.mq.matches) && this.slides().length > 1;
      }

      sync() {
        if (!this.active()) {
          this.teardown();
        } else if (!this.swiper) {
          loadSwiper(this.dataset.src)
            .then(() => this.setup())
            .catch(() => {});
        }
      }

      gap() {
        return parseFloat(getComputedStyle(this).columnGap) || 0;
      }

      per(name) {
        return parseFloat(this.dataset[name]) || 1;
      }

      setup() {
        if (this.swiper || !window.Swiper || !this.isConnected || !this.active()) return;
        const slides = this.slides();
        this.saved = [this.viewport, this.track, ...slides].map((el) => [
          el,
          KEPT.map((name) => [name, el.getAttribute(name)]),
        ]);
        slides.forEach((el) => el.classList.add('os-carousel__slide'));

        const options = {
          wrapperClass: 'os-carousel__track',
          slideClass: 'os-carousel__slide',
          slidesPerView: this.per('perM'),
          spaceBetween: this.gap(),
          breakpoints: {
            750: { slidesPerView: this.per('perT') },
            990: { slidesPerView: this.per('perD') },
          },
          speed: 500,
          grabCursor: true,
          watchSlidesProgress: true,
          a11y: { enabled: true },
          on: {
            // The gap is fluid: re-read it before Swiper measures again.
            beforeResize: (swiper) => {
              swiper.params.spaceBetween = this.gap();
            },
            transitionEnd: () => this.pauseHidden(),
          },
        };
        if (this.dataset.free === 'true') options.freeMode = { enabled: true, momentumBounce: false };

        const prev = this.querySelector('.os-carousel__arrow--prev');
        const next = this.querySelector('.os-carousel__arrow--next');
        if (prev && next) options.navigation = { prevEl: prev, nextEl: next };
        const dots = this.querySelector('.os-carousel__dots');
        if (dots) options.pagination = { el: dots, clickable: true, bulletElement: 'button' };

        this.swiper = new window.Swiper(this.viewport, options);
        this.classList.add('is-active');
      }

      teardown() {
        if (!this.swiper) return;
        this.swiper.destroy(true, false);
        this.swiper = null;
        for (const [el, attrs] of this.saved || []) {
          for (const [name, value] of attrs) {
            if (value === null) el.removeAttribute(name);
            else el.setAttribute(name, value);
          }
          el.classList.remove(...[...el.classList].filter((c) => c.startsWith('swiper-')), 'os-carousel__slide');
        }
        this.saved = null;
        const dots = this.querySelector('.os-carousel__dots');
        if (dots) {
          dots.replaceChildren();
          dots.className = 'os-carousel__dots';
        }
        this.querySelectorAll('.os-carousel__arrow').forEach((button) => {
          button.disabled = false;
          button.classList.remove(...[...button.classList].filter((c) => c.startsWith('swiper-')));
        });
        this.classList.remove('is-active');
      }

      // Endless scroll. Clones of the slides fill the row: one set before the
      // originals (so a row bleeding past the left edge isn't empty there)
      // and as many after as cover the screen. The animation then moves the
      // row from -1 to -2 set widths, which looks the same at both ends.
      setupMarquee() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotion = () => this.buildMarquee();
        this.motion.addEventListener('change', this.onMotion);
        // Built now, and again when the viewport's width changes (the observer
        // alone isn't enough: it doesn't run while the page is in the background).
        let width = Math.round(this.viewport.getBoundingClientRect().width);
        this.buildMarquee();
        this.resizeObserver = new ResizeObserver(([entry]) => {
          const next = Math.round(entry.contentRect.width);
          if (next === width) return;
          width = next;
          this.buildMarquee();
        });
        this.resizeObserver.observe(this.viewport);
      }

      buildMarquee() {
        this.track.querySelectorAll('[data-os-clone]').forEach((clone) => clone.remove());
        this.classList.remove('is-running', 'is-static');
        const slides = this.slides();
        if (!slides.length) return;
        if (this.motion.matches) {
          this.classList.add('is-static');
          return;
        }
        const first = slides[0].getBoundingClientRect();
        const last = slides[slides.length - 1].getBoundingClientRect();
        const set = last.right - first.left + this.gap();
        if (set <= 0) return;
        const clone = () => {
          const fragment = document.createDocumentFragment();
          for (const slide of slides) {
            const copy = slide.cloneNode(true);
            copy.setAttribute('data-os-clone', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.inert = true;
            for (const el of [copy, ...copy.querySelectorAll('*')]) {
              el.removeAttribute('id');
              for (const attr of [...el.attributes]) {
                if (attr.name.startsWith('data-shopify-editor')) el.removeAttribute(attr.name);
              }
            }
            fragment.append(copy);
          }
          return fragment;
        };
        this.track.prepend(clone());
        const after = Math.ceil(window.innerWidth / set) + 1;
        for (let i = 0; i < after; i++) this.track.append(clone());
        const speed = parseFloat(this.dataset.speed) || 40;
        this.track.style.setProperty('--os-marquee-distance', `${set}px`);
        this.track.style.setProperty('--os-marquee-duration', `${set / speed}s`);
        this.classList.add('is-running');
      }

      // A video that was playing stops once its slide is scrolled away.
      pauseHidden() {
        for (const slide of this.slides()) {
          if (slide.classList.contains('swiper-slide-visible')) continue;
          slide.querySelectorAll('video').forEach((video) => {
            if (!video.paused && !video.autoplay) video.pause();
          });
        }
      }

      // Theme editor: selecting a slide (or a block inside it) brings it into view.
      reveal(target) {
        if (!this.swiper || !(target instanceof Element)) return;
        const index = this.slides().findIndex((slide) => slide === target || slide.contains(target));
        if (index >= 0) this.swiper.slideTo(index);
      }
    }

    if (!customElements.get('os-carousel')) customElements.define('os-carousel', OsCarousel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["os-stat-ring"] && !Shopify.designMode) return;
  try {
    // Fill the ring when it scrolls into view. The ring is only emptied here,
  // so it stays full without JavaScript or for reduced motion.
  if (!customElements.get('os-stat-ring')) {
    customElements.define(
      'os-stat-ring',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.classList.contains('os-ring--animate')) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;
          this.classList.add('is-armed');
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              // Next frame, so the empty state is painted before the fill.
              requestAnimationFrame(() => this.classList.add('is-in'));
              this.observer.disconnect();
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["os-video"] && !Shopify.designMode) return;
  try {
    // Autoplaying video: paused (with controls) for visitors who prefer
  // reduced motion, and paused while off screen to save battery.
  if (!customElements.get('os-video')) {
    customElements.define(
      'os-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (this.video && this.hasAttribute('data-play-button')) this.setUpPlayButton();
          if (!this.video || !this.hasAttribute('data-autoplay')) return;
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.visible = true;
          this.sync = () => {
            if (this.motion.matches) {
              this.video.pause();
              this.video.controls = true;
            } else if (this.visible) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          };
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.sync();
          });
          this.observer.observe(this);
          this.motion.addEventListener('change', this.sync);
          this.sync();
        }

        // Tap to play: the video gets sound and controls, and the button
        // goes away once it plays (by the button or otherwise).
        setUpPlayButton() {
          this.querySelector('.os-video__play')?.addEventListener('click', () => {
            this.video.muted = false;
            this.video.controls = true;
            this.video.play().catch(() => {});
          });
          this.video.addEventListener('play', () => this.classList.add('is-playing'), { once: true });
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.motion?.removeEventListener('change', this.sync);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    let swiperLoader = null;

  function loadSwiper(src) {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoader) return swiperLoader;

    swiperLoader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return swiperLoader;
  }

  class SlideshowBlock extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.swiper');
      if (!this.viewport) return;

      const slides = this.viewport.querySelectorAll('.swiper-wrapper > *');
      if (slides.length < 2) return;

      loadSwiper(this.dataset.swiperSrc)
        .then(() => this.init())
        .catch(() => {
        });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      if (!window.Swiper || !this.isConnected) return;
      if (this.swiper) this.swiper.destroy(true, true);

      const slides = this.viewport.querySelectorAll('.swiper-wrapper > *');
      for (const slide of slides) {
        slide.classList.add('swiper-slide');
      }

      const perView = parseFloat(this.dataset.perView) || 1;
      const perViewMobile = parseFloat(this.dataset.perViewMobile) || 1;
      const spaceBetween = parseInt(this.dataset.spaceBetween, 10) || 0;
      const bySlideWidth = this.dataset.slideSizing === 'width';
      const slideWidth = parseInt(this.dataset.slideWidth, 10) || 320;

      const desktopPerView = bySlideWidth ? 'auto' : perView;

      const centered = this.dataset.centered === 'true';
      const wantsLoop = this.dataset.infinite === 'true';
      const scaled = this.classList.contains('block-slideshow--scale-inactive');

      let onScreen = bySlideWidth
        ? Math.ceil(this.viewport.clientWidth / (slideWidth + spaceBetween)) + 1
        : Math.ceil(perView);
      onScreen = Math.max(onScreen, Math.ceil(perViewMobile));
      if (centered && onScreen % 2 === 0) onScreen += 1;
      const spare = Math.max(0, Math.min(2, slides.length - onScreen - 1));
      const canLoop = wantsLoop && slides.length >= onScreen + 1 + spare;

      const options = {
        speed: 600,
        loop: canLoop,
        rewind: wantsLoop && !canLoop,
        loopAdditionalSlides: spare,
        grabCursor: true,
        a11y: { enabled: true },
        slidesPerView: perViewMobile,
        spaceBetween: spaceBetween,
        centeredSlides: centered,
        maxBackfaceHiddenSlides: scaled ? 0 : 10,
        autoHeight: this.dataset.autoHeight === 'true' && perView === 1 && !bySlideWidth,
        breakpoints: { 750: { slidesPerView: desktopPerView, spaceBetween: spaceBetween } },
      };

      if (this.dataset.effect === 'fade' && perView === 1 && perViewMobile === 1 && !bySlideWidth) {
        options.effect = 'fade';
        options.fadeEffect = { crossFade: true };
      }

      if (this.dataset.autoplay === 'true') {
        options.autoplay = {
          delay: parseInt(this.dataset.interval, 10) || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      if (this.dataset.pagination === 'true') {
        options.pagination = { el: this.querySelector('.swiper-pagination'), clickable: true };
      }

      if (this.dataset.arrows === 'true') {
        options.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      this.swiper = new window.Swiper(this.viewport, options);
    }
  }

  if (!customElements.get('slideshow-block')) {
    customElements.define('slideshow-block', SlideshowBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
